import {useQuery} from '@tanstack/react-query'
import dayjs from 'dayjs'
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {QUERIES} from '../../../_metronic/helpers'
import {fileSrc} from '../../../_component/fileUtils'
import {GallerysQueryResponse} from '../../modules/apps/gallery/gallerys-list/core/_models'
import {v2_get_request_api} from '../../../api/get'

export const queryKey =
  'page_size=24&filter={"is_view_on_web":true,"status":true}&includes=GalleryImage'

export const GalleryPage: FC = () => {
  const {data: gallery}: Partial<{data: GallerysQueryResponse}> = useQuery(
    [QUERIES.GALLERY_LIST, queryKey],
    v2_get_request_api
  )

  return (
    <div id='kt_app_content' className='app-content flex-column-fluid'>
      {/*begin::Content container*/}
      <div id='kt_app_content_container' className='app-container container-xxl'>
        {/*begin::About card*/}
        <div className='card'>
          {/*begin::Body*/}
          <div className='card-body p-lg-17'>
            {/*begin::Statistics*/}
            <div className='card bg-light mb-18'>
              {/*begin::Body*/}
              <div className='card-body py-15'>
                {/*begin::Row*/}
                <div className='row g-10'>
                  {/*begin::Col*/}
                  {gallery?.entities?.map((entity) => (
                    <Link to={`/web/gallery/${entity.id}`} className='col-md-4' key={entity.id}>
                      {/*begin::Publications post*/}
                      <div className='card-xl-stretch me-md-6'>
                        {/*begin::Overlay*/}
                        <div
                          id='carouselExampleCaptions'
                          className='carousel slide'
                          data-bs-ride='carousel'
                        >
                          <div className='carousel-indicators'>
                            {entity?.gallery_images?.map((_, i) => (
                              <button
                                key={i}
                                type='button'
                                data-bs-target='#carouselExampleCaptions'
                                data-bs-slide-to={`${i}`}
                                className={i === 0 ? 'active' : ''}
                                aria-current={i === 0 ? 'true' : 'false'}
                                aria-label={`Slide ${i + 1}`}
                              ></button>
                            ))}
                          </div>
                          <div className='carousel-inner'>
                            {entity?.gallery_images?.map((image, i) => (
                              <div key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`}>
                                <div className='text-center px-5 pt-5 pt-lg-10 px-lg-5'>
                                  <img
                                    src={fileSrc(image.image)}
                                    className='card-rounded shadow mw-100'
                                    alt=''
                                  />
                                  <div className='carousel-caption d-none d-md-block'>
                                    <h1 className='text-light'>{image.caption}</h1>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/*end::Overlay*/}
                        {/*begin::Body*/}
                        <div className='m-0'>
                          {/*begin::Title*/}
                          <div className='fs-4 text-dark fw-bold text-hover-primary text-dark lh-base'>
                            {entity.title}
                          </div>
                          {/*end::Title*/}
                          {/*begin::Content*/}
                          <div className='fs-6 fw-bold'>
                            {/*begin::Author*/}
                            <span
                              // href='../../demo1/dist/apps/projects/users.html'
                              className='text-gray-700 text-hover-primary'
                            >
                              {entity.account?.user?.name}
                            </span>
                            {/*end::Author*/}
                            {/*begin::Date*/}
                            <span className='text-muted'>
                              {dayjs(entity.created_at).format('MMM DD YYYY')}
                            </span>
                            {/*end::Date*/}
                          </div>
                          {/*end::Content*/}
                        </div>
                        {/*end::Body*/}
                      </div>
                      {/*end::Publications post*/}
                    </Link>
                  ))}
                  {/*end::Col*/}
                </div>
                {/*end::Row*/}
              </div>
              {/*end::Body*/}
            </div>
            {/*end::Statistics*/}
          </div>
          {/*end::Body*/}
        </div>
        {/*end::About card*/}
      </div>
      {/*end::Content container*/}
    </div>
  )
}
